import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteBaixaManualEstoque } from '../service';
import {
  DELETE_BAIXAR_MANUAL_ESTOQUE,
  DELETE_BAIXAR_MANUAL_ESTOQUE_PENDING,
  DELETE_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
  DELETE_BAIXAR_MANUAL_ESTOQUE_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteBaixaManualEstoque(action) {
  yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.ESTOQUE_BAIXA_MANUAL_EXCLUIR);

  try {
    const a = yield call(deleteBaixaManualEstoque, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteBaixaManualEstoque() {
  yield takeLatest(DELETE_BAIXAR_MANUAL_ESTOQUE, sagaDeleteBaixaManualEstoque)
}
